export const UserRole = {
  MASTER_ROLE: 1,
  USER_ROLE: 2,
  SPECTATOR_ROLE: 3,
} as const;

export type UserRoles = (typeof UserRole)[keyof typeof UserRole];
